<template>
  <div>
    <b-row class="mt-4 mb-2">
      <b-col xl="4">
        <h4>Team Users</h4>
        <p class="small">This section is where you manage your ClarityNOW Team Users. These users have one of three roles. Agent, these users will have access to their own ClarityNOW portal. Editor, these users have the ability to edit your ClarityNOW portal. Example would be your administration team. Viewer, these users have the ability to only view your ClarityNOW portal. Example would be your Accountant.</p>
      </b-col>
      <b-col xl="8">
        <p class="text-danger" v-if="teamName"><strong>You are a member of the {{ teamName }} Team.</strong></p>
        <b-card no-body class="card-danger card-outline">
          <b-card-header>
            <b-button variant="primary" v-b-modal.invite-modal>Invite User</b-button>
          </b-card-header>
          <b-card-body>
            <h3 class="mb-0">Outstanding Invitations</h3>
          </b-card-body>
          <b-table responsive small :items="invites" :fields="inviteFields" v-if="invites">
            <template #cell(role)="row">
              {{ row.item.role | capitalize }}
            </template>

            <template #cell(actions)="row">
              <b-button size="sm" variant="danger" @click="destroy(row.item.id)"><i class="fa fa-trash"></i> Delete</b-button>
            </template>
          </b-table>
          <loading-panel v-else></loading-panel>
        </b-card>
        <b-card no-body>
          <b-card-header>
            <h3 class="mb-0"><strong>Current Users</strong></h3>
          </b-card-header>
          <b-table responsive small :items="items" :fields="fields" :perPage="perPage" :currentPage="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" v-if="items">
            <template #cell(roles)="row">
              <b-badge variant="secondary" v-for="(role, key) in row.item.roles" :key="key" class="mr-2">
                {{ role }}
              </b-badge>
            </template>
            <template #cell(actions)="row">
              <b-button size="sm" variant="danger" @click="destroyUser(row.item.id)"><i class="fa fa-trash"></i> Delete</b-button>
            </template>
          </b-table>
          <loading-panel v-else></loading-panel>
          <b-card-footer>
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="members"></b-pagination>
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>
    <invite-modal
      :userRoute="userRoute"
      :members="members"
      :roles="roles"
      :subBasic="subBasic"
      :subStandard="subStandard"
      :subPremium="subPremium"
      @getInvites="getInvites">
    </invite-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import LoadingPanel from '@/components/LoadingPanel';
import errorsMixin from '@/mixins/errors-mixin';
import InviteModal from '@/views/Components/Modals/InviteModal';

export default {
  mixins: [errorsMixin],
  components: {
    LoadingPanel,
    InviteModal,
  },
  props: {
    members: null
  },
  data: function() {
    return {
      items: null,
      invites: null,
      fields: [
        {
          key: 'name'
        },
        {
          key: 'email'
        },
        {
          key: 'roles'
        },
        {
          key: 'team_role'
        },
        {
          key: 'actions',
          label: ''
        }
      ],
      form: {
        name: null,
        email: null,
        role_id: null
      },
      selectedRole: "Select Role...",
      inviteFields: ['name', 'email', 'role', 'token', 'team_role', { key: 'actions', label: '' }],
      roles: [],
      delete_id: null,
      member: null,
      teamName: null,
      perPage: 10,
      currentPage: 1,
      sortBy: 'name',
      sortDesc: false,
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      subBasic: 'profile/subBasic',
      subStandard: 'profile/subStandard',
      subPremium: 'profile/subPremium'
    }),
    subscribed() {
      return this.subBasic + this.subStandard || this.subPremium;
    },
    newUser() {
      return (this.member == 'newUser');
    },
    rows() {
      return this.items ? this.items.length : 0;
    }
  },
  methods: {
    async getItems() {
      axios.get(this.userRoute + "/team-users")
      .then(response => {
        this.items = response.data;
      });
    },
    async getInvites() {
      axios.get(this.userRoute + "/invites")
        .then(response => {
          this.invites = response.data;
        });
    },
    async addUser() {
      axios.post(this.userRoute + "/invites", this.form)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
        this.getInvites();
        this.selectedRole = "Select Role...";
        this.form.name = "";
        this.form.email = "";
        this.form.role_id = null;
        this.member = null;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getRoles() {
      axios.get(this.userRoute + "/assignable-roles")
      .then(response => {
        this.roles = response.data;
      });
    },
    setRole(role) {
      this.form.role_id = role.id;
      this.selectedRole = role.name;
    },
    async destroyUser(id) {
      axios.delete(this.userRoute + "/team-users/" + id, {
        userId: id,
        _method: "DELETE"
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
        this.getItems();
      })
      .catch(error => {
        this.error(error);
      });
    },
    async destroy(id) {
      axios.delete(this.userRoute + "/invites/" + id, {
        invite: id,
        _method: "DELETE"
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.getInvites();
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    mapUser(member) {
      this.form.name = member.name;
      this.form.email = member.email;
    },
    async getTeamName() {
      axios.get(this.userRoute + "/member-team")
      .then(response => {
        this.teamName = response.data; 
      });
    }
  },
  created() {
    this.getItems();
    this.getInvites();
    this.getRoles();

    if(this.$store.getters.admin == false) {
      this.getTeamName();
    }
  }
};
</script>